<template>
  <div class="dashboard-stats-container">
    <div v-show="showSkeleton" class="dashboard-stats-grid">
      <div v-for="i in visibleStatCount" :key="`skeleton-${i}`" class="dashboard-stat-item">
        <div class="dashboard-stat-card dashboard-stat-card--skeleton">
          <div class="dashboard-stat-card__body">
            <div class="uk-skeleton uk-skeleton-circle skeleton-icon"></div>
            <div class="skeleton-copy">
              <div class="uk-skeleton uk-skeleton-text skeleton-number"></div>
              <div class="uk-skeleton uk-skeleton-text skeleton-label"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="!showSkeleton" class="dashboard-stats-grid">
      <div v-if="isAssignmentVisible" class="dashboard-stat-item">
        <router-link
          :to="{ name: 'user.my-assignment', query: { ...$route.query, tab: 'with_expired', val: false } }"
          class="dashboard-stat-card"
        >
          <div class="dashboard-stat-card__body">
            <span class="dashboard-stat-card__icon" aria-hidden="true"><i class="uil-book-open"></i></span>
            <div class="dashboard-stat-card__copy">
              <span class="stat-number">{{ dashboard_item?.assigned_educations_count || 0 }}</span>
              <span class="stat-label">{{ $t('home.education_assigned') }}</span>
            </div>
          </div>
        </router-link>
      </div>

      <div v-if="isCatalogTrainingVisible" class="dashboard-stat-item">
        <router-link
          :to="{ name: 'user.education-category', query: { ...$route.query, tab: 'show_registered_trainings', tabId: 1 } }"
          class="dashboard-stat-card"
        >
          <div class="dashboard-stat-card__body">
            <span class="dashboard-stat-card__icon" aria-hidden="true"><i class="uil-books"></i></span>
            <div class="dashboard-stat-card__copy">
              <span class="stat-number">{{ dashboard_item?.assigned_trainings_count || 0 }}</span>
              <span class="stat-label">{{ catalogTrainingLabel }}</span>
            </div>
          </div>
        </router-link>
      </div>

      <div class="dashboard-stat-item">
        <router-link
          :to="{ name: 'user.my-assignment', query: { ...$route.query, tab: 'completed', val: true } }"
          class="dashboard-stat-card"
        >
          <div class="dashboard-stat-card__body">
            <span class="dashboard-stat-card__icon" aria-hidden="true"><i class="uil-presentation-check"></i></span>
            <div class="dashboard-stat-card__copy">
              <span class="stat-number">{{ dashboard_item?.completed_educations_count || 0 }}</span>
              <span class="stat-label">{{ $t('home.i_completed_education') }}</span>
            </div>
          </div>
        </router-link>
      </div>

      <div v-if="isGiftVisible" class="dashboard-stat-item">
        <router-link to="gift" class="dashboard-stat-card">
          <div class="dashboard-stat-card__body">
            <span class="dashboard-stat-card__icon" aria-hidden="true"><i class="uil-gift"></i></span>
            <div class="dashboard-stat-card__copy">
              <span class="stat-number">{{ dashboard_item?.gifts_count || 0 }}</span>
              <span class="stat-label">{{ $t('home.i_won_a_gift') }}</span>
            </div>
          </div>
        </router-link>
      </div>

      <div v-show="isPointCoinVisible" class="dashboard-stat-item">
        <router-link :to="{ name: 'user.my-statistics' }" class="dashboard-stat-card dashboard-stat-card--accent">
          <div class="dashboard-stat-card__body">
            <span class="dashboard-stat-card__icon" aria-hidden="true"><i class="uil-coins"></i></span>
            <div class="dashboard-stat-card__copy">
              <span class="stat-number stat-number--split">{{ dashboard_item?.points_count || 0 }} / {{ dashboard_item?.coins_count || 0 }}</span>
              <span class="stat-label">{{ $t('home.point_coin') }}</span>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: "aes", isCompression: true });

export default {
  name: "DashboardStats",
  props: {
    dashboard_item: {
      type: Object,
      required: true,
      default: () => ({})
    },
    module_list: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      subdomain: null
    }
  },
  computed: {
    resolvedMenuItems() {
      const menu = this.module_list?.menu;
      if (Array.isArray(menu) && menu.length > 0) {
        return menu;
      }

      try {
        const cached = ls.get("dashboardMenuList");
        if (Array.isArray(cached?.menu) && cached.menu.length > 0) {
          return cached.menu;
        }
      } catch (e) {
        // localStorage okunamazsa varsayılan sayı kullanılır
      }

      return [];
    },
    isGiftVisible() {
      const giftItem = this.resolvedMenuItems.find(item => item.type === "gift");
      return giftItem?.status === 1 ?? false;
    },
    isAssignmentVisible() {
      const assignmentItem = this.resolvedMenuItems.find(item => item.type === "my-assignment");
      return assignmentItem?.status === 1 ?? false;
    },
    isCatalogTrainingVisible() {
      const catalogItem = this.resolvedMenuItems.find(item => item.type === "education-category");
      return catalogItem?.status === 1 ?? false;
    },
    isPointCoinVisible() {
      const company = this.$store.getters["COMPANY/SELF"];
      return company?.alias !== "izeltaselaletleri";
    },
    catalogTrainingLabel() {
      if (this.subdomain === 'ato.softinya.com' || this.subdomain === 'akademi.atonet.org.tr') {
        return 'Eğitime Kayıt Olundu';
      }
      return this.$t('general.catalog_training_assigned');
    },
    visibleStatCount() {
      let count = 1;
      if (this.isAssignmentVisible) count += 1;
      if (this.isCatalogTrainingVisible) count += 1;
      if (this.isGiftVisible) count += 1;
      if (this.isPointCoinVisible) count += 1;
      return count;
    },
    hasData() {
      const hasDashboardData = this.dashboard_item &&
        Object.keys(this.dashboard_item).length > 0 &&
        this.dashboard_item.assigned_educations_count !== undefined &&
        this.dashboard_item.completed_educations_count !== undefined &&
        this.dashboard_item.points_count !== undefined &&
        this.dashboard_item.coins_count !== undefined;

      return hasDashboardData && this.resolvedMenuItems.length > 0;
    },
    showSkeleton() {
      return !this.hasData;
    }
  },
  mounted() {
    this.subdomain = window.location.hostname;
  }
}
</script>

<style scoped>
.dashboard-stats-container {
  padding-top: 28px;
  margin-bottom: 1rem;
}

.dashboard-stats-grid {
  display: grid;
  gap: 12px;
}

.dashboard-stat-item {
  min-width: 0;
  display: flex;
}

/* Kart — global course-card.foruser'dan bağımsız */
.dashboard-stat-card {
  display: flex;
  flex: 1;
  width: 100%;
  position: relative;
  overflow: visible;
  text-decoration: none;
  color: inherit;
  background: #fff;
  border: none;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.15s ease, box-shadow 0.2s ease;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.dashboard-stat-card:hover {
  color: inherit;
  text-decoration: none;
}

.dashboard-stat-card__body {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 0.5rem 0.5rem;
  min-height: 120px;
}

.dashboard-stat-card__icon {
  position: absolute;
  top: -25px;
  left: 50%;
  margin-left: -25px;
  width: 50px;
  height: 50px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  padding: 0.4rem;
  font-size: 2.5rem;
  line-height: 1;
  color: #ae71ff;
  background-color: #f0e6ff;
  flex-shrink: 0;
}

.dashboard-stat-card__icon i {
  font-size: inherit;
  line-height: 1;
}

.dashboard-stat-card__copy {
  width: 100%;
  text-align: center;
  min-width: 0;
}

.stat-number {
  display: block;
  font-family: var(--font-secondary);
  font-weight: 700;
  line-height: 1.2;
  color: inherit;
  font-variant-numeric: tabular-nums;
}

.stat-label {
  display: block;
  font-family: var(--font-primary);
  font-weight: 500;
  line-height: 1.3;
  color: inherit;
  opacity: 0.85;
}

.dashboard-stat-card--accent {
  background: var(--backgroundColor, #666cff);
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.dashboard-stat-card--accent .dashboard-stat-card__icon {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.7);
}

.dashboard-stat-card--accent .stat-label {
  opacity: 0.7;
  color: #fff;
}

/* Mobile */
@media (max-width: 639px) {
  .dashboard-stats-container {
    padding-top: 0;
    margin-bottom: 4px;
  }

  .dashboard-stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    align-items: stretch;
  }

  .dashboard-stat-item:last-child:nth-child(odd) {
    grid-column: 1 / -1;
  }

  .dashboard-stat-card {
    height: 100%;
    overflow: visible;
    border-radius: 10px;
    box-shadow: none;
    border: 1px solid #e2e8f0;
    min-height: 88px;
  }

  .dashboard-stat-card--accent {
    border-color: transparent;
    box-shadow: none;
  }

  /* Puan/coin kartında mobil WebView :hover durumu metin rengini değiştirmemeli. */
  .dashboard-stat-card--accent,
  .dashboard-stat-card--accent:hover,
  .dashboard-stat-card--accent:focus,
  .dashboard-stat-card--accent:active {
    color: #fff;
    text-decoration: none;
  }

  .dashboard-stat-card--accent .dashboard-stat-card__copy {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  .dashboard-stat-card--accent .stat-label {
    min-height: 0;
    color: #fff;
  }

  .dashboard-stat-card:active {
    transform: scale(0.98);
  }

  .dashboard-stat-card__body {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    min-height: 88px;
    height: 100%;
    padding: 12px;
  }

  .dashboard-stat-card__icon {
    position: static;
    top: auto;
    left: auto;
    margin: 0;
    width: 40px;
    height: 40px;
    padding: 0;
    font-size: 20px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    color: #64748b;
    background-color: transparent;
  }

  .dashboard-stat-card--accent .dashboard-stat-card__icon {
    border-color: rgba(255, 255, 255, 0.35);
    background-color: rgba(255, 255, 255, 0.7);
    color: #fff;
  }

  .dashboard-stat-card__copy {
    flex: 1;
    text-align: left;
    min-width: 0;
  }

  .stat-number {
    font-size: var(--text-md);
    margin: 0;
    line-height: 1.25;
    white-space: nowrap;
  }

  .stat-number--split {
    font-size: var(--text-md);
  }

  .stat-label {
    min-height: calc(var(--text-sm) * 1.5 * 2);
    font-size: var(--text-sm);
    line-height: 1.5;
    margin: 0;
    opacity: 1;
    color: #64748b;
    white-space: normal;
    overflow: visible;
  }

  .dashboard-stat-card--accent .stat-label {
    opacity: 0.68;
    color: #fff;
  }

  .dashboard-stat-card:hover {
    box-shadow: none;
    transform: none;
  }

  .skeleton-icon {
    width: 40px !important;
    height: 40px !important;
    min-width: 40px;
    border-radius: 8px !important;
    flex-shrink: 0;
  }

  .skeleton-copy {
    flex: 1;
    min-width: 0;
  }

  .skeleton-number {
    height: 1rem !important;
    width: 40px !important;
    margin: 0 0 4px !important;
  }

  .skeleton-label {
    height: 2.625rem !important;
    width: 80px !important;
    margin: 0 !important;
  }
}

@media (max-width: 400px) {
  .dashboard-stats-grid {
    gap: 8px;
  }

  .dashboard-stat-card__body {
    padding: 10px;
    gap: 8px;
  }

  .dashboard-stat-card__icon,
  .skeleton-icon {
    width: 36px !important;
    height: 36px !important;
    min-width: 36px;
    font-size: 18px;
  }
}

/* Tablet */
@media (min-width: 640px) and (max-width: 959px) {
  .dashboard-stats-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .dashboard-stat-card:active {
    transform: scale(0.98);
  }

  .stat-number {
    font-size: 1.5rem;
    margin-bottom: 4px;
  }

  .stat-label {
    font-size: 12px;
  }

  .stat-number--split {
    font-size: 1.3rem;
  }
}

/* Desktop */
@media (min-width: 960px) {
  .dashboard-stats-grid {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }

  .dashboard-stat-card__body {
    min-height: 105px;
    height: 105px;
  }

  .dashboard-stat-card--skeleton .dashboard-stat-card__body {
    min-height: 105px;
    height: 105px;
  }

  .stat-number {
    font-size: 1.75rem;
    margin-bottom: 4px;
  }

  .stat-label {
    font-size: 0.8rem;
  }

  .stat-number--split {
    font-size: 1.5rem;
  }

  .dashboard-stat-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  }
}

@media (max-width: 959px) {
  .dashboard-stat-card:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transform: none;
  }
}

@media (max-width: 639px) {
  .dashboard-stat-card:hover {
    box-shadow: none !important;
    transform: none !important;
  }
}
</style>
